// extracted by mini-css-extract-plugin
export default {"mainWidth":"ComponentWidth_mainWidth__OSpvp","containerContent":"ComponentWidth_containerContent__XqfSY","appear":"ComponentWidth_appear__H66jn"};